import apiConfig from "../../apiConfig";

export const validateAgentData = async (
	at,
	{
		Active_Status_Id,
		Agent_Name_AR = "",
		Agent_Name_EN = "",
		Agent_Phone,
		Agent_Id,
	}
) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/AGENTS/Validate_Agent_Data",
		{
			Active_Status_Id,
			Agent_Name_AR,
			Agent_Name_EN,
			Agent_Phone,
			Agent_Id,
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response.data;
};
